const HotIcon = ({ size = "12px" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 32 32"
    >
      <path
        fill="url(#a)"
        d="M12.555 8.935c1.537-2.397 2.447-4.611 2.921-6.177.182-.6.95-.845 1.406-.415 6.873 6.481 9.12 11.43 9.567 17.148.328 5.531-2.39 10.453-9.687 10.453-6.85 0-11.907-4.781-11.22-12.36.412-4.528 2.173-7.979 3.58-10.033.438-.639 1.351-.648 1.856-.06l1.259 1.466c.087.101.246.09.318-.022"
      />
      <path
        fill="url(#b)"
        d="M12.555 8.935c1.537-2.397 2.447-4.611 2.921-6.177.182-.6.95-.845 1.406-.415 6.873 6.481 9.12 11.43 9.567 17.148.328 5.531-2.39 10.453-9.687 10.453-6.85 0-11.907-4.781-11.22-12.36.412-4.528 2.173-7.979 3.58-10.033.438-.639 1.351-.648 1.856-.06l1.259 1.466c.087.101.246.09.318-.022"
      />
      <path
        fill="url(#c)"
        d="M12.555 8.935c1.537-2.397 2.447-4.611 2.921-6.177.182-.6.95-.845 1.406-.415 6.873 6.481 9.12 11.43 9.567 17.148.328 5.531-2.39 10.453-9.687 10.453-6.85 0-11.907-4.781-11.22-12.36.412-4.528 2.173-7.979 3.58-10.033.438-.639 1.351-.648 1.856-.06l1.259 1.466c.087.101.246.09.318-.022"
      />
      <path
        fill="url(#d)"
        d="M12.555 8.935c1.537-2.397 2.447-4.611 2.921-6.177.182-.6.95-.845 1.406-.415 6.873 6.481 9.12 11.43 9.567 17.148.328 5.531-2.39 10.453-9.687 10.453-6.85 0-11.907-4.781-11.22-12.36.412-4.528 2.173-7.979 3.58-10.033.438-.639 1.351-.648 1.856-.06l1.259 1.466c.087.101.246.09.318-.022"
      />
      <path
        fill="url(#e)"
        d="M12.555 8.935c1.537-2.397 2.447-4.611 2.921-6.177.182-.6.95-.845 1.406-.415 6.873 6.481 9.12 11.43 9.567 17.148.328 5.531-2.39 10.453-9.687 10.453-6.85 0-11.907-4.781-11.22-12.36.412-4.528 2.173-7.979 3.58-10.033.438-.639 1.351-.648 1.856-.06l1.259 1.466c.087.101.246.09.318-.022"
      />
      <path
        fill="url(#f)"
        d="M12.555 8.935c1.537-2.397 2.447-4.611 2.921-6.177.182-.6.95-.845 1.406-.415 6.873 6.481 9.12 11.43 9.567 17.148.328 5.531-2.39 10.453-9.687 10.453-6.85 0-11.907-4.781-11.22-12.36.412-4.528 2.173-7.979 3.58-10.033.438-.639 1.351-.648 1.856-.06l1.259 1.466c.087.101.246.09.318-.022"
      />
      <path
        fill="url(#g)"
        d="M12.555 8.935c1.537-2.397 2.447-4.611 2.921-6.177.182-.6.95-.845 1.406-.415 6.873 6.481 9.12 11.43 9.567 17.148.328 5.531-2.39 10.453-9.687 10.453-6.85 0-11.907-4.781-11.22-12.36.412-4.528 2.173-7.979 3.58-10.033.438-.639 1.351-.648 1.856-.06l1.259 1.466c.087.101.246.09.318-.022"
      />
      <path
        fill="url(#h)"
        d="M12.555 8.935c1.537-2.397 2.447-4.611 2.921-6.177.182-.6.95-.845 1.406-.415 6.873 6.481 9.12 11.43 9.567 17.148.328 5.531-2.39 10.453-9.687 10.453-6.85 0-11.907-4.781-11.22-12.36.412-4.528 2.173-7.979 3.58-10.033.438-.639 1.351-.648 1.856-.06l1.259 1.466c.087.101.246.09.318-.022"
      />
      <g filter="url(#i)">
        <path
          fill="url(#j)"
          d="M10.178 19.877c1.302-3.1 3.975-6.529 5.78-8.39a1.336 1.336 0 0 1 1.872-.038c3.461 3.189 4.503 6.072 5.387 9.428.92 3.492 0 9.118-6.921 9.118-5.96 0-8.026-5.578-6.118-10.118"
        />
        <path
          fill="url(#k)"
          d="M10.178 19.877c1.302-3.1 3.975-6.529 5.78-8.39a1.336 1.336 0 0 1 1.872-.038c3.461 3.189 4.503 6.072 5.387 9.428.92 3.492 0 9.118-6.921 9.118-5.96 0-8.026-5.578-6.118-10.118"
        />
        <path
          fill="url(#l)"
          d="M10.178 19.877c1.302-3.1 3.975-6.529 5.78-8.39a1.336 1.336 0 0 1 1.872-.038c3.461 3.189 4.503 6.072 5.387 9.428.92 3.492 0 9.118-6.921 9.118-5.96 0-8.026-5.578-6.118-10.118"
        />
      </g>
      <path
        fill="url(#m)"
        d="M10.178 19.877c1.302-3.1 3.975-6.529 5.78-8.39a1.336 1.336 0 0 1 1.872-.038c3.461 3.189 4.503 6.072 5.387 9.428.92 3.492 0 9.118-6.921 9.118-5.96 0-8.026-5.578-6.118-10.118"
      />
      <path
        fill="url(#n)"
        d="M10.178 19.877c1.302-3.1 3.975-6.529 5.78-8.39a1.336 1.336 0 0 1 1.872-.038c3.461 3.189 4.503 6.072 5.387 9.428.92 3.492 0 9.118-6.921 9.118-5.96 0-8.026-5.578-6.118-10.118"
      />
      <g filter="url(#o)">
        <path
          fill="url(#p)"
          d="M11.814 11.539c2.315-3.39 3.67-7.058 4.083-7.962-.603 4.634-2.36 8.028-5.668 12.398-2.646 3.496-3.124 6.488-3.101 7.217-.827-5.562 1.791-7.416 4.686-11.653"
        />
      </g>
      <g filter="url(#q)">
        <path
          fill="url(#r)"
          d="M9.814 7.874c-1.3 1.614-3.884 6.09-3.82 11.084 1.28-5.122 4.275-6.736 3.82-11.084"
        />
      </g>
      <defs>
        <radialGradient
          id="a"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="rotate(-179.474 12.046 9.805)scale(17.0988 25.7861)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF953D" />
          <stop offset="1" stopColor="#FF5141" />
        </radialGradient>
        <radialGradient
          id="b"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="rotate(-157.937 6.712 6.816)scale(10.3441 17.8495)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CE5327" />
          <stop offset="1" stopColor="#CE5327" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="d"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="rotate(24.015 -31.353 18.85)scale(3.10465 25.6991)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFAA7B" />
          <stop offset="1" stopColor="#FFAA7B" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="e"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(.843 3.74668 -4.675 1.05188 9.31 6.25)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF5E47" />
          <stop offset="1" stopColor="#FF5E47" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="f"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(.37467 10.13047 -9.3768 .3468 16.429 1.366)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF2F3C" />
          <stop offset="1" stopColor="#FF2F3C" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="g"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(2.07795 .9835 -1.9737 4.17002 13.9 4.8)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF846C" />
          <stop offset="1" stopColor="#FF846C" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="h"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(-.89842 2.09375 -.4798 -.20588 12.458 8.21)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFA682" />
          <stop offset="1" stopColor="#FFA682" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="j"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="rotate(-168.558 11.823 11.126)scale(10.0291 12.4891)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFDA2F" />
          <stop offset="1" stopColor="#FF8E41" />
        </radialGradient>
        <radialGradient
          id="k"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="rotate(69.044 -.045 13.31)scale(14.1425 12.2879)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FD5639" />
          <stop offset="1" stopColor="#FE5533" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="l"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(-9.74917 .98358 -2.40823 -23.87023 19.239 20.629)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".628" stopColor="#D7812D" stopOpacity="0" />
          <stop offset="1" stopColor="#D7812D" />
        </radialGradient>
        <radialGradient
          id="n"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="rotate(143.063 8.353 13.24)scale(16.0546 11.6174)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".772" stopColor="#F18A52" stopOpacity="0" />
          <stop offset="1" stopColor="#F18A52" />
        </radialGradient>
        <linearGradient
          id="c"
          x1="18.336"
          x2="18.336"
          y1="29.944"
          y2="24.846"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF7583" />
          <stop offset="1" stopColor="#FF7583" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="m"
          x1="16.503"
          x2="16.503"
          y1="10.612"
          y2="14.259"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F95131" />
          <stop offset="1" stopColor="#F95131" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="p"
          x1="14.996"
          x2="7.655"
          y1="4.255"
          y2="22.732"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF7558" />
          <stop offset="1" stopColor="#F38758" />
        </linearGradient>
        <linearGradient
          id="r"
          x1="9.541"
          x2="5.582"
          y1="8.144"
          y2="19.479"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF815B" />
          <stop offset="1" stopColor="#FF9C6D" />
        </linearGradient>
        <filter
          id="i"
          width="14.525"
          height="18.91"
          x="9.49"
          y="11.085"
          color-interpolation-filters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dx=".5" />
          <feGaussianBlur stdDeviation=".25" />
          <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
          <feColorMatrix values="0 0 0 0 0.952941 0 0 0 0 0.615686 0 0 0 0 0.364706 0 0 0 1 0" />
          <feBlend in2="shape" result="effect1_innerShadow_18_15821" />
        </filter>
        <filter
          id="o"
          width="11.424"
          height="22.115"
          x="5.723"
          y="2.327"
          color-interpolation-filters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            result="effect1_foregroundBlur_18_15821"
            stdDeviation=".625"
          />
        </filter>
        <filter
          id="q"
          width="6.868"
          height="14.084"
          x="4.492"
          y="6.374"
          color-interpolation-filters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            result="effect1_foregroundBlur_18_15821"
            stdDeviation=".75"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default HotIcon;
